import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import styles from "../../pages/NSF/Nsf.module.css";
import { BsCalendar, BsCreditCard } from "react-icons/bs";
import { FaUser, FaFileAlt } from "react-icons/fa";

const NSFHistoryTable = ({ cases, onShowHistory }) => {
  if (!cases || cases.length === 0) {
    return (
      <div className={styles.nsfContainer}>
        <h2 className={styles.nsfTitle}>NSF History</h2>
        <p className={styles.nsfDescription}>
          No historical NSF records found
        </p>
      </div>
    );
  }

  return (
    <div className={styles.nsfContainer}>
      <h2 className={styles.nsfTitle}>Historical NSF Cases</h2>
      <p className={styles.nsfDescription}>
        View past NSF occurrences
      </p>

      <Row className="g-4">
        {cases.map((nsfCase) => (
          <Col key={nsfCase.id} xs={12}>
            <Card className={`${styles.nsfCard} border-0 shadow-sm`}>
              <Card.Body className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className={styles.userAvatar}>
                    <FaUser size={24} className="text-secondary" />
                  </div>
                  <div className="ms-3">
                    <h5 className={styles.borrowerName}>{nsfCase.borrower}</h5>
                    <div className={styles.loanDetails}>
                      <div className="d-flex align-items-center mb-2">
                        <FaFileAlt className="me-2 text-secondary" />
                        <span>Loan: {nsfCase.account}</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <BsCalendar className="me-2 text-secondary" />
                        <span>NSF Date: {nsfCase.dateFormatted}</span>
                        <span className="mx-4"></span>
                        <span>{nsfCase.amount}</span>
                        <span className="mx-4"></span>
                        <BsCreditCard className="me-2 text-secondary" />
                        <span>****{nsfCase.BankNumber?.slice(-4) || String(nsfCase.accountNumber || nsfCase.accountLast4 || "").slice(-4)}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className={`${styles.overdueTag} me-3`}>
                    {Math.floor(
                      (new Date() - new Date(nsfCase.date)) /
                        (1000 * 60 * 60 * 24)
                    )}{" "}
                    days ago
                  </div>
                  <Button
                    variant="primary"
                    onClick={() => onShowHistory && onShowHistory(nsfCase)}
                  >
                    View History
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default NSFHistoryTable;

